import { useCallback } from 'react'
import { advancedDelete, advancedPost } from '../../api/client'
import { useAdvancedOverviewState } from '../../api/AdvancedOverviewProvider'
import { AdvancedCareTeamMember } from '../../api/types'
import { RoleCategoryId } from './types'

export type CareTeamMembersState = {
  members: AdvancedCareTeamMember[]
  addMember: (categoryId: RoleCategoryId, providerUid: string) => Promise<void>
  removeMember: (memberId: string) => Promise<void>
}

export const useCareTeamMembers = (uid: string): CareTeamMembersState => {
  const overview = useAdvancedOverviewState()
  const members = overview.status === 'ready' ? overview.overview.careTeam : []
  const refetch = overview.status === 'ready' ? overview.retry : undefined

  const addMember = useCallback(
    async (categoryId: RoleCategoryId, providerUid: string) => {
      await advancedPost(`/patients/${encodeURIComponent(uid)}/care-team`, { providerUid, role: categoryId })
      refetch?.()
    },
    [uid, refetch]
  )

  const removeMember = useCallback(
    async (memberId: string) => {
      await advancedDelete(`/patients/${encodeURIComponent(uid)}/care-team/${encodeURIComponent(memberId)}`)
      refetch?.()
    },
    [uid, refetch]
  )

  return { members, addMember, removeMember }
}
